/**
 * @calendly/http-tools axios interceptor sets `headers.common['X-Page-Rendered-At']` from
 * `document.querySelector('meta[name=page-rendered-at]')?.content` only (not from per-request `headers`).
 * Publisher often has no such meta, so the interceptor sends null (serialized as the string "null").
 */
export const syncPageRenderedAtMetaForHttpTools = () => {
  if (typeof document === 'undefined') return
  const iso = new Date().toISOString()
  let el = document.querySelector('meta[name="page-rendered-at"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', 'page-rendered-at')
    document.head.appendChild(el)
  }
  el.setAttribute('content', iso)
}
